const patternIdRegex = /pattern\s+id="([^"]+)"/;

/**
 * @deprecated
 */
export const findPatternId = (svgContent: string) => {
    const matches = svgContent.match(patternIdRegex);

    if (matches && matches.length > 1) {
        return matches[1];
    } else {
        return null;
    }
}
